
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/satellite",
      function () {
        return require("private-next-pages/satellite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/satellite"])
      });
    }
  